import { useStaticQuery, graphql } from "gatsby";

export const useWpMenu = () => {
  const data = useStaticQuery(graphql`
    query MenuQuery {
      wpMenu(slug: { eq: "primary" }) {
        id
        menuItems {
          nodes {
            id
            order
            connectedNode {
              node {
                ... on WpPage {
                  id
                  slug
                  title
                  pageContent {
                    cover
                  }
                  featuredImage {
                    node {
                      localFile {
                        childImageSharp {
                          gatsbyImageData
                          resize {
                            aspectRatio
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return data;
};
